/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Update market making platform request
 */
export interface UpdateMarketMakingPlatformRequest {
  id: number;
  /**
   * Human readable label, e.g. New Zerohash
   */
  displayName: string;
  /**
   * URL path segment of the platform API, e.g. kaali-zerohash-api
   */
  apiPath?: string;
  /**
   * Ledger account id used for hedging on this platform
   */
  hedgeAccountId?: number;
  /**
   * Hidden platforms are not offered in the UI
   */
  hidden: boolean;
}
